import {GlobalVariables} from "../GlobalVariables";
import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class HeaderNavs {
	constructor() {
		this.header = document.querySelector(".header-main");

		if (this.header) {
			this.overlay = this.header.querySelector(".overlay");
			this.navBg = this.header.querySelector(".nav-main-bg");

			this.toggleMobileNav();
			this.initMegaMenu();

			this.navCursor();

			this.flip();

			document.addEventListener("escape.pressed", () => {
				this.closeAllLev2();
			});

			GlobalVariables.resizeCallbacks.push(this);
		}
	}

	toggleMobileNav() {
		const openTrigger = this.header.querySelector(".nav-toggle");
		if (openTrigger) {
			openTrigger.addEventListener("click", () => {
				if (document.body.classList.contains("navs-open")) {
					this.closeMobileNav();
				} else {
					this.openMobileNav();
				}
			});
		}
	}

	openMobileNav() {
		document.body.classList.add("navs-open");

		GlobalVariables.lenis?.stop();
	}

	closeMobileNav() {
		document.body.classList.remove("navs-open");

		const activeMenuItems = this.header.querySelectorAll(".menu-item-lev1.active");
		activeMenuItems.forEach(item => {
			item.classList.remove("active");
			const subnav = item.querySelector(".lev2");
			if (subnav) {
				subnav.classList.remove("show");
			}
		});

		GlobalVariables.lenis?.start();
	}

	initMegaMenu() {
		// Un clic sur l'overlay ferme tout
		this.overlay.addEventListener("click", () => {
			this.closeAllLev2();
		});

		this.navMain = this.header.querySelector(".nav-main");
		this.levelOneItems = this.navMain.querySelectorAll(".menu-item-lev1.menu-item-has-children");

		this.levelOneItems.forEach(levelOne => {
			levelOne.toggle = levelOne.querySelector("button[data-header='toggler']");
			levelOne.levelTwo = levelOne.querySelector(".lev2-items");

			if (!levelOne.levelTwo) {
				return;
			}

			levelOne.toggle.addEventListener("click", (e) => {
				e.preventDefault();

				if (levelOne.classList.contains("active")) {
					this.header.classList.remove("subnav-active");
					this.adjustNavBgHeight(levelOne.levelTwo);
					levelOne.classList.remove("active");
					levelOne.levelTwo.classList.remove("show");
					levelOne.toggle.setAttribute("aria-expanded", false);

					if (window.innerWidth > GlobalVariables.header.getBreakpoint()) {
						GlobalVariables.lenis?.start();
					}
				} else {
					this.closeAllLev2();

					this.header.classList.add("subnav-active");
					this.adjustNavBgHeight(levelOne.levelTwo);
					levelOne.classList.add("active");
					levelOne.levelTwo.classList.add("show");
					levelOne.toggle.setAttribute("aria-expanded", true);

					if (window.innerWidth > GlobalVariables.header.getBreakpoint()) {
						GlobalVariables.lenis?.stop();
					}
				}
			});
		});
	}

	closeAllLev2() {
		this.header.classList.remove("subnav-active");
		this.levelOneItems.forEach(item => {
			item.classList.remove("active");
			item.levelTwo.classList.remove("show");
			item.querySelector("button[data-header='toggler']").setAttribute("aria-expanded", "false");
		});

		if (window.innerWidth > GlobalVariables.header.getBreakpoint()) {
			GlobalVariables.lenis?.start();
		}
	}

	restoreNav() {
		this.closeAllLev2();
		this.closeMobileNav();
	}

	adjustNavBgHeight(levelTwo) {
		if (this.navBg && window.innerWidth > GlobalVariables.header.getBreakpoint()) {
			gsap.to(this.navBg, {duration: 0.3, height: levelTwo.offsetHeight});
		}
	}

	navCursor(){

		document.fonts.ready.then(() => {

			const navs = document.querySelectorAll('.nav-cursor-container');

			navs.forEach( nav => {

				const cursor = nav.querySelector('.nav-cursor');
				const items = nav.querySelectorAll('.menu-item-lev1');

				function moveCursor(el) {
					cursor.style.width = `${el.offsetWidth}px`;
					cursor.style.left = `${el.offsetLeft}px`;
				}

				items.forEach((item) => {
					// Déplace le curseur au survol
					item.addEventListener('mouseenter', (e) => {
						moveCursor(e.target);
					});

					// Optionnel : Retour à l'élément "actif" quand on quitte le menu
					item.addEventListener('mouseleave', () => {
						const activeItem = nav.querySelector('.menu-item-lev1.current-menu-item');
						if (activeItem) moveCursor(activeItem);
					});
				});

				// Initialisation au chargement (sur l'item actif par défaut)
				const initialActive = nav.querySelector('.menu-item-lev1.current-menu-item');
				if (initialActive) moveCursor(initialActive);
			});

		});

	}

	flip(){
		const menu = document.querySelector('.nav-main');
		const origin = document.querySelector('.header-nav');
		const destination = document.querySelector('.main-nav-sticky-inner');

		const start = document.body.classList.contains('home') ? window.innerHeight * 2 : "150px top";

		ScrollTrigger.create({
			trigger: "body", // Déclenche l'action quand on scroll
			start: start, // Ajuste selon tes besoins
			end: "bottom bottom",
			onEnter: () => {
				destination.appendChild(menu);
			},
			onLeaveBack: () => {
				origin.appendChild(menu);
			}
		});
	}

	resize() {
		this.restoreNav();
	}
}
